<template><section><h2>刻度</h2>
<p>可以通过 <code v-pre>tickStep</code> 和 <code v-pre>tickLength</code> 分别控制 tick 的生成数和长度。当 <code v-pre>tickLength</code> 为负值时，将在外圈绘制刻度。</p>
<block-demo tip="" source="
const { Chart, Gauge} = qcharts

const chart = new Chart({ container: &#39;#app&#39; })

const colors = [&#39;#49d088&#39;, &#39;#FE5555&#39;, &#39;#F4B30E&#39;, &#39;#473C8B&#39;]

const gauge = new Gauge({
  min: 0,
  max: 10,
  percent:7.3,
  tickStep: 1,
  tickLength: -10
})

gauge.style(&#39;title&#39;, { fontSize: 36 })

chart.append(gauge)
"><pre v-pre><code v-pre class="language-javascript">
<span class="hljs-keyword">const</span> { Chart, Gauge} = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })

<span class="hljs-keyword">const</span> colors = [<span class="hljs-string">'#49d088'</span>, <span class="hljs-string">'#FE5555'</span>, <span class="hljs-string">'#F4B30E'</span>, <span class="hljs-string">'#473C8B'</span>]

<span class="hljs-keyword">const</span> gauge = <span class="hljs-keyword">new</span> Gauge({
  <span class="hljs-attr">min</span>: <span class="hljs-number">0</span>,
  <span class="hljs-attr">max</span>: <span class="hljs-number">10</span>,
  <span class="hljs-attr">percent</span>:<span class="hljs-number">7.3</span>,
  <span class="hljs-attr">tickStep</span>: <span class="hljs-number">1</span>,
  <span class="hljs-attr">tickLength</span>: <span class="hljs-number">-10</span>
})

gauge.style(<span class="hljs-string">'title'</span>, { <span class="hljs-attr">fontSize</span>: <span class="hljs-number">36</span> })

chart.append(gauge)
</code></pre>
</block-demo><h3>刻度上文字</h3>
<p>可以通过 <code v-pre>labelOffset</code> 设置文字和刻度之间的距离。</p>
<block-demo tip="" source="
const { Chart, Gauge } = qcharts

const chart = new Chart({ container: &#39;#app&#39; })

const gauge = new Gauge({
  min: 0,
  max: 10,
  percent:7.3,
  tickStep: 1,
  tickLength: 10,
  labelOffset: 20,
})

gauge.style(&#39;title&#39;, { fontSize: 36 })

chart.append(gauge)
"><pre v-pre><code v-pre class="language-javascript">
<span class="hljs-keyword">const</span> { Chart, Gauge } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })

<span class="hljs-keyword">const</span> gauge = <span class="hljs-keyword">new</span> Gauge({
  <span class="hljs-attr">min</span>: <span class="hljs-number">0</span>,
  <span class="hljs-attr">max</span>: <span class="hljs-number">10</span>,
  <span class="hljs-attr">percent</span>:<span class="hljs-number">7.3</span>,
  <span class="hljs-attr">tickStep</span>: <span class="hljs-number">1</span>,
  <span class="hljs-attr">tickLength</span>: <span class="hljs-number">10</span>,
  <span class="hljs-attr">labelOffset</span>: <span class="hljs-number">20</span>,
})

gauge.style(<span class="hljs-string">'title'</span>, { <span class="hljs-attr">fontSize</span>: <span class="hljs-number">36</span> })

chart.append(gauge)
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>